export default __webpack_public_path__ + "static/media/oven_veggies.08574b63.jpg";